import React from 'react';

export const Check = ({ color = '#020202', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240.608 240.608" {...props}>
    <path
      fill={color}
      d="M208.789,29.972l31.819,31.82L91.763,210.637L0,118.876l31.819-31.82l59.944,59.942L208.789,29.972z"
    />
  </svg>
);
